import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      quote: '"Desde que uso LactiGo, mis tiempos de recuperación se han reducido a la mitad. Es un producto indispensable en mi rutina."',
      author: 'Ana García',
      title: 'Maratonista Profesional',
      img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=761&q=80'
    },
    {
      quote: '"El alivio es casi instantáneo. Perfecto para después de un WOD intenso. ¡Lo recomiendo a toda mi comunidad de CrossFit!"',
      author: 'Carlos Ruiz',
      title: 'Entrenador de CrossFit',
      img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80'
    },
    {
      quote: '"No más piernas pesadas al día siguiente de una larga ruta en bicicleta. LactiGo realmente funciona como promete."',
      author: 'Sofia Hernandez',
      title: 'Ciclista de Montaña',
      img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'
    }
  ];

  return (
    <section id="testimonials" className="section">
      <div className="container">
        <h2 className="section-title">Lo que dicen nuestros atletas</h2>
        <div className="row">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-md-4 mb-4" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="card bg-dark text-white h-100 border-secondary">
                <div className="card-body text-center">
                  <img src={testimonial.img} alt={testimonial.author} className="rounded-circle mb-3" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                  <p className="card-text fst-italic">{testimonial.quote}</p>
                  <footer className="blockquote-footer mt-3 text-white">{testimonial.author} <cite title="Source Title">({testimonial.title})</cite></footer>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;